import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RouterView, useRoute } from "vue-router";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { onMounted } from "vue";
import { useTask } from "@/composables/tasks/useTask";
import TaskDependencyWarningModal from "@/components/v2/Tasks/Task/TaskDependencyWarningModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { startObserver } = useTask();

const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key)

const init = async () => {
    const tasksStore = useTasksStore();
    
    // Check if we already have the correct task loaded
    if (tasksStore.activeTask && tasksStore.activeTask.key === taskKey) {
        return;
    }
    
    const task = await TasksService.startTask(taskKey);
    if (!task) return;

    await tasksStore.setActiveTask(task);
    startObserver();
};

onMounted(() => {
    init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutMain, null, {
    mainArea: _withCtx(() => [
      _createVNode(TaskDependencyWarningModal),
      _createVNode(_unref(RouterView))
    ]),
    _: 1
  }))
}
}

})